import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FloatingBubbles from '../components/FloatingBubbles';
import axios from 'axios';

export default function ForgotPassword() {
  const { API } = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError('Une erreur est survenue. Réessaie plus tard.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <FloatingBubbles />
      <div style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '40px 32px', boxShadow: '0 8px 32px rgba(43,108,176,0.12)', border: '1px solid rgba(190,227,248,0.4)' }}>

          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📧</div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--dark)', marginBottom: '12px' }}>Email envoyé !</h2>
              <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.7, marginBottom: '24px' }}>
                Si l'adresse <strong>{email}</strong> est associée à un compte, tu recevras un email avec un lien de réinitialisation dans quelques minutes.
              </p>
              <p style={{ fontSize: '13px', color: 'var(--muted)', marginBottom: '24px' }}>Vérifie aussi tes spams.</p>
              <Link to="/login" style={{ color: 'var(--blue)', fontWeight: 600, fontSize: '14px' }}>← Retour à la connexion</Link>
            </div>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: '28px' }}>
                <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔑</div>
                <h2 style={{ fontSize: '24px', fontWeight: 800, color: 'var(--dark)', marginBottom: '8px' }}>Mot de passe oublié</h2>
                <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.6 }}>Entre ton adresse email et on t'envoie un lien pour réinitialiser ton mot de passe.</p>
              </div>

              {error && <div style={{ background: '#FFF5F5', border: '1px solid #FED7D7', borderRadius: '10px', padding: '12px 16px', fontSize: '13px', color: 'var(--red)', marginBottom: '16px' }}>{error}</div>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Adresse email</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ton@email.com" required
                    style={{ width: '100%', padding: '12px 16px', border: '1.5px solid var(--blue-border)', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
                    onFocus={e => e.target.style.borderColor = 'var(--blue)'} onBlur={e => e.target.style.borderColor = 'var(--blue-border)'}
                  />
                </div>
                <button type="submit" disabled={loading || !email.trim()} style={{ background: 'var(--blue)', color: '#fff', border: 'none', padding: '13px', borderRadius: '12px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(43,108,176,0.3)', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Envoi...' : 'Envoyer le lien →'}
                </button>
              </form>

              <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '13px', color: 'var(--muted)' }}>
                <Link to="/login" style={{ color: 'var(--blue)', fontWeight: 600 }}>← Retour à la connexion</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
}
